import React from "react";
import Typography from "@material-ui/core/Typography";

const Orderrow = ({ bgcolor, numresult }) => {
  const firstcolor = bgcolor[0];
  const seocondcolor = bgcolor[1];

  return (
    <>
      <div className="record-main-no">
        <div
          className="recordcomm"
          style={{
            background:
              seocondcolor && firstcolor
                ? `linear-gradient( to right,${firstcolor} 0%,${firstcolor} 50%,${seocondcolor} 50%,${seocondcolor} 100% )`
                : firstcolor,
          }}
        >
          <span >{numresult}</span>
        </div>
      </div>
    </>
  );
};

export default Orderrow;
